import { Component, OnInit } from "@angular/core";
import { FeaturedPost } from "src/app/models/blog-post";
import { BlogService } from "src/app/services/blog.service";

@Component({
  selector: "app-featured-posts",
  templateUrl: "./featured-posts.component.html",
  styleUrls: ["./featured-posts.component.sass"],
})
export class FeaturedPostsComponent implements OnInit {
  firstThreePosts: FeaturedPost[] = [];

  constructor(private blogService: BlogService) {}

  ngOnInit(): void {
    this.loadFeaturedPosts();
  }

  loadFeaturedPosts(): void {
    this.blogService.getFeaturedPosts().subscribe((response) => {
      this.firstThreePosts = response.data.articles.slice(0, 3);
    });
  }

  getImageUrl(url: string): string {
    return this.blogService.getImageUrl(url);
  }
}
